var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntregaRapida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2355 4556 c-77 -25 -145 -67 -200 -122 -170 -173 -177 -447 -16 -626 46 -52 152 -128 178 -128 10 0 13 46 13 245 l0 245 29 32 29 33 272 5 271 5 -35 71 c-46 90 -131 173 -223 217 -61 28 -79 32 -173 34 -67 2 -119 -2 -145 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 3945 l0 -205 91 0 c108 0 155 12 204 52 62 52 78 96 83 236 l4 122 -191 0 -191 0 0 -205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 3997 c-20 -17 -27 -33 -27 -57 0 -24 7 -40 27 -57 27 -23 28 -23 297 -23 l271 0 29 29 c37 37 37 65 0 102 l-29 29 -271 0 c-269 0 -270 0 -297 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765 3635 c-32 -31 -32 -66 -1 -102 l24 -28 359 -3 c388 -2 396 -1 421 52 16 32 2 80 -29 96 -10 6 -169 10 -384 10 l-366 0 -24 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 3557 c-122 -41 -228 -124 -284 -220 -14 -23 -93 -205 -175 -405 -125 -301 -151 -372 -151 -413 l0 -49 383 0 382 0 89 280 c49 154 94 280 99 280 40 0 817 -102 835 -110 13 -6 56 -10 97 -10 l75 0 0 -70 0 -70 126 0 126 0 -6 28 c-3 15 -15 79 -26 142 -11 63 -25 139 -31 168 l-10 52 -162 0 c-140 0 -166 -3 -192 -18 l-30 -19 -295 179 c-337 204 -389 231 -496 258 -110 29 -267 27 -354 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 3298 c-49 -26 -59 -77 -24 -122 l20 -26 459 0 c252 0 466 3 475 6 24 10 46 60 39 89 -3 14 -18 34 -31 45 -25 19 -42 20 -472 20 -303 -1 -452 -4 -466 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4125 3256 c-115 -51 -140 -202 -49 -288 43 -40 75 -48 195 -48 l109 0 0 175 0 175 -112 0 c-72 -1 -124 -6 -143 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 2315 l0 -345 480 0 480 0 0 345 0 345 -99 0 -100 0 -3 -161 -3 -161 -28 -24 c-28 -24 -30 -24 -248 -24 l-221 0 -29 29 -29 29 0 156 0 156 -100 0 -100 0 0 -345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 2565 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3720 2019 c0 -393 -3 -577 -11 -591 -12 -23 -48 -40 -364 -173 l-226 -95 -387 2 -387 3 -3 313 -2 312 -431 0 c-487 0 -529 -4 -664 -70 -147 -72 -253 -179 -321 -325 -24 -52 -114 -376 -114 -410 0 -3 649 -4 1442 -3 l1442 3 204 235 c112 129 235 271 272 315 l68 81 -109 469 c-60 259 -112 478 -115 488 -5 15 -21 17 -150 17 l-144 0 0 -571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 2131 l0 -161 354 0 c333 0 355 -1 377 -19 23 -19 24 -25 29 -193 l5 -173 128 -3 128 -3 -3 233 c-3 218 -4 236 -26 279 -36 74 -87 125 -160 161 l-67 33 -382 3 -383 3 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4122 1198 c-115 -134 -242 -278 -283 -322 l-73 -79 54 -50 c30 -28 84 -64 120 -81 61 -29 72 -31 180 -31 109 0 119 2 183 32 225 107 321 370 213 587 -36 74 -139 186 -170 186 -8 0 -109 -109 -224 -242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2527 1394 c-4 -4 -7 -36 -7 -71 l0 -63 255 0 c281 0 274 -2 232 60 -45 68 -70 75 -282 78 -105 2 -194 0 -198 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 791 c0 -26 94 -132 150 -169 86 -58 151 -75 264 -70 76 3 102 9 157 35 37 17 86 48 109 69 49 45 100 111 100 131 0 11 -69 13 -390 13 -221 0 -390 -4 -390 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntregaRapida);
export default __webpack_public_path__ + "static/media/entrega-rapida.d12f586c26923b08f08ab6ad730fa044.svg";
export { ForwardRef as ReactComponent };